export default "<spec-app-type2-long-string-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type2-long-string-table>\n";